import { ApiError } from "api/shared";
import useAxios from "axios-hooks";
import { useCallback } from "react";
import { AllowedParamTypes, formatUrl } from "utils";

export const useManualQuery = <R, T extends AllowedParamTypes>(
  urlTemplate: string
) => {
  const [response, callback] = useAxios<R, ApiError>(
    {
      url: "",
    },
    { manual: true }
  );

  const execute = useCallback(
    (urlParams: T, queryParams?: unknown) => {
      return callback({
        url: formatUrl<T>(urlTemplate, urlParams),
        params: queryParams,
      });
    },
    [urlTemplate, callback]
  );

  return [response, execute] as const;
};
